import { lazyLoadView } from '@router/routes'

export default [
  // 키오스크 선택
  {
    path: '/game/kiosk',
    component: () => lazyLoadView(import('@views/kiosk.vue')),
    meta: {
      authRequired: true,
    },
  },

  // 게임 선택
  {
    path: '/games/:game/scenario',
    component: () => lazyLoadView(import('@games/scenario.vue')),
    props: true,
    meta: {
      authRequired: true,
    },
  },

  // 난이도 선택
  {
    path: '/games/:game/:gameId/mode',
    component: () => lazyLoadView(import('@games/mode.vue')),
    props: true,
    meta: {
      authRequired: true,
    },
  },

  // 게임 시작
  {
    path: '/games/:game/:gameId/play',
    component: () => lazyLoadView(import('@games/play.vue')),
    props: true,
    meta: {
      authRequired: true,
    },
  },
]
